import { message } from 'antd';

message.config({
  maxCount: 3,
});

// Zwykłe powiadomienia antd z kolorową ikoną — wygląd wszystkich powiadomień ustawia App.less
const success = (messageContent: string) => message.success(messageContent);

const error = (messageContent: string) => message.error(messageContent);

const Message = {
  success,
  error,
};

export default Message;
export { success, error };
